/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconCoreHelp = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M8 0c4.42 0 8 3.58 8 8s-3.58 8-8 8-8-3.58-8-8 3.58-8 8-8zm0 14.914A6.911 6.911 0 0 0 14.914 8c0-3.82-3.093-6.914-6.914-6.914S1.086 4.179 1.086 8 4.179 14.914 8 14.914z"
    />
    <path
      fill="currentColor"
      d="M7.288 12.184v-1.201H8.49v1.201h-1.2zM5.114 5.926c.098-.8.388-1.414.87-1.84.483-.425 1.12-.638 1.913-.638.84 0 1.51.228 2.01.685.5.457.75 1.01.75 1.659a2.1 2.1 0 0 1-.263 1.037c-.176.316-.52.7-1.032 1.154-.343.305-.568.53-.674.674-.105.144-.183.31-.234.498s-.08.492-.088.914H7.353c-.004-.14-.006-.246-.006-.317 0-.414.058-.771.175-1.072.086-.226.225-.455.416-.685.141-.168.394-.413.76-.736s.602-.579.711-.77c.11-.192.164-.4.164-.627 0-.41-.16-.77-.48-1.081a1.628 1.628 0 0 0-1.178-.466c-.45 0-.824.14-1.125.422-.3.281-.498.72-.592 1.318l-1.084-.129z"
    />
  </svg>
);

IconCoreHelp.displayName = 'IconCoreHelp';

IconCoreHelp.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconCoreHelp);
IconCoreHelp.displayName = 'IconCoreHelp';
